import { useState, useRef } from 'react';
import useOutsideClick from '../../../../../../hook/useOutsideClick';
import './styles.scss';

export const TaskMenu = ({
  task,
  shiftRecordID,
  hasResident,
  canManageTasks,
  setEditTaskData,
  handleSetTaskCommentsData,
  setDeleteTaskModalData,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const wrapperRef = useRef(null);
  const closeMenu = () => {
    setIsOpen(false);
  };

  useOutsideClick(wrapperRef, closeMenu);

  return (
    <div className="dropdown task-dropdown-menu" ref={wrapperRef}>
      <button onClick={() => setIsOpen((state) => !state)} className="btn btn-outline task-dropdown-btn">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
            fill="#667085"
          />
          <path
            d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
            fill="#667085"
          />
          <path
            d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
            fill="#667085"
          />
          <path
            d="M9.99984 10.832C10.4601 10.832 10.8332 10.4589 10.8332 9.9987C10.8332 9.53846 10.4601 9.16536 9.99984 9.16536C9.5396 9.16536 9.1665 9.53846 9.1665 9.9987C9.1665 10.4589 9.5396 10.832 9.99984 10.832Z"
            stroke="#667085"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.99984 4.9987C10.4601 4.9987 10.8332 4.6256 10.8332 4.16536C10.8332 3.70513 10.4601 3.33203 9.99984 3.33203C9.5396 3.33203 9.1665 3.70513 9.1665 4.16536C9.1665 4.6256 9.5396 4.9987 9.99984 4.9987Z"
            stroke="#667085"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.99984 16.6654C10.4601 16.6654 10.8332 16.2923 10.8332 15.832C10.8332 15.3718 10.4601 14.9987 9.99984 14.9987C9.5396 14.9987 9.1665 15.3718 9.1665 15.832C9.1665 16.2923 9.5396 16.6654 9.99984 16.6654Z"
            stroke="#667085"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </button>
      {isOpen && (
        <ul className="dropdown-menu">
          {!!canManageTasks && (
            <li>
              <button
                className="btn btn-left btn-full btn-text dropdown-menu-item-btn"
                onClick={() => setEditTaskData({ ...task, shiftRecordID, hasResident })}
              >
                <i className="icon-icon-edit" />
                Edit Task
              </button>
            </li>
          )}
          <li>
            <button
              className="btn btn-left btn-full btn-text dropdown-menu-item-btn"
              onClick={() => handleSetTaskCommentsData(shiftRecordID, task)}
            >
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.5 12.5C17.5 12.942 17.3244 13.366 17.0118 13.6785C16.6993 13.9911 16.2754 14.1667 15.8333 14.1667H5.83333L2.5 17.5V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H15.8333C16.2754 2.5 16.6993 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V12.5Z"
                  stroke="#101828"
                  strokeWidth="1.67"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              Add Comment
            </button>
          </li>
          {!!canManageTasks && (
            <li>
              <button
                className="btn btn-left btn-full btn-danger btn-text dropdown-menu-item-btn"
                onClick={() => setDeleteTaskModalData({ shiftRecordID, taskID: task.id })}
              >
                <i className="icon-remove" />
                Delete Task
              </button>
            </li>
          )}
        </ul>
      )}
    </div>
  );
};
